<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 5640 5640"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="2820" cy="2820" r="2820"/>
  <g id="_794548480">
   <path class="fil1" d="M3117 3504c199,-23 358,116 380,291 25,202 -120,361 -293,382 -198,25 -359,-120 -380,-292 -25,-200 118,-361 293,-381zm-705 -1132c202,-48 368,106 400,265 41,204 -104,368 -264,400 -425,86 -593,-555 -136,-665zm941 226c100,-33 186,73 132,164 -23,38 -132,137 -168,173 -112,113 -979,997 -1029,1013 -99,32 -184,-72 -135,-163 27,-50 752,-761 847,-856 59,-59 294,-311 353,-331zm-590 2038c197,0 341,-11 522,-81 255,-99 456,-240 623,-462 54,-73 110,-155 148,-243 139,-326 178,-637 62,-981 -111,-334 -305,-594 -509,-867l-592 -790c-79,-126 -102,-208 -204,-208 -83,0 -132,111 -188,203 -79,130 -422,581 -545,731 -211,258 -456,622 -557,925 -106,315 -85,597 26,908 62,172 227,407 365,522 151,126 255,188 436,260 25,10 50,18 73,25 84,27 233,58 340,58z"/>
   <path class="fil0" d="M3353 2598c-59,20 -294,272 -353,331 -95,95 -820,806 -847,856 -49,91 36,195 135,163 50,-16 917,-900 1029,-1013 36,-36 145,-135 168,-173 54,-91 -32,-197 -132,-164z"/>
   <path class="fil0" d="M2368 2728c-30,-158 203,-186 223,-41 20,151 -198,170 -223,41zm44 -356c-457,110 -289,751 136,665 160,-32 305,-196 264,-400 -32,-159 -198,-313 -400,-265z"/>
   <path class="fil0" d="M3131 3732c150,-44 192,185 60,218 -145,36 -205,-175 -60,-218zm-14 -228c-175,20 -318,181 -293,381 21,172 182,317 380,292 173,-21 318,-180 293,-382 -22,-175 -181,-314 -380,-291z"/>
   <path class="fil1" d="M2368 2728c25,129 243,110 223,-41 -20,-145 -253,-117 -223,41z"/>
   <path class="fil1" d="M3131 3732c-145,43 -85,254 60,218 132,-33 90,-262 -60,-218z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'HumidityMeter',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
    .fil0 {fill:#56D6D1}
</style>
